export default __webpack_public_path__ + "static/media/R_Raposa.1131fa15.mp3";